import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { createFeature, createSelector } from '@ngrx/store';
import { DefaultDraftItem } from '../../models/default-draft-template.model';
import { PlanningDefaultDraftsApiActions } from './planning-default-drafts.actions';

export interface PlanningDefaultDraftsState extends EntityState<DefaultDraftItem> {
  cursor: string;
}

const adapter: EntityAdapter<DefaultDraftItem> = createEntityAdapter<DefaultDraftItem>();

const initialState: PlanningDefaultDraftsState = adapter.getInitialState({
  cursor: null
});

const planningDefaultDraftsReducer = createReducer(
  initialState,
  on(PlanningDefaultDraftsApiActions.clearStore, () =>
    adapter.removeAll({
      ...initialState,
      cursor: null
    })
  ),

  on(PlanningDefaultDraftsApiActions.getDefaultDraftsSuccess, (state, {drafts, cursor}) => {
    // If no existing cursor, this is initial load - replace all
    // If existing cursor, this is pagination - append new items
    return state.cursor 
      ? adapter.addMany(drafts, {...state, cursor: cursor, loading: false, error: null})
      : adapter.setMany(drafts, {...state, cursor: cursor, loading: false, error: null});
  }),

  on(PlanningDefaultDraftsApiActions.updateDefaultDraftSuccess, (state, {draft}) =>
    adapter.updateOne({id: draft.id, changes: draft}, state)
  ),

  on(PlanningDefaultDraftsApiActions.renameDefaultDraftSuccess, (state, {draft}) =>
    adapter.updateOne({id: draft.id, changes: draft}, state)
  ),

  on(PlanningDefaultDraftsApiActions.deleteDefaultDraftSuccess, (state, {id}) =>
    adapter.removeOne(id, state)
  )
);

export const planningDefaultDraftsFeature = createFeature({
  name: 'planningDefaultDrafts',
  reducer: planningDefaultDraftsReducer,
  extraSelectors: ({selectPlanningDefaultDraftsState}) => ({
    ...adapter.getSelectors(selectPlanningDefaultDraftsState),
    selectCursor: createSelector(
      selectPlanningDefaultDraftsState,
      (state) => state.cursor
    )
  })
});
